const columnsByType = {
  academico: [
    "ID_Aluno", "Status_Aluno", "ID_Curso", "Nome_Curso", "ID_Turma",
    "ID_Disciplina", "Nome_Disciplina", "Modalidade_Disciplina", "Frequencia",
    "Nota_Intermediaria", "Nota_Prova_Final", "Media_Final",
    "Nota_Media_Aprovacao", "DT_Inicio_Disciplina", "DT_Termino_Disciplina",
    "ID_Docente", "Nome_Docente", "CH_Teorica", "CH_Pratica", "CH_Extensao", "CH_Total"
  ],
  aluno: [
    "ID_Aluno", "EstadoCivil_Aluno", "Cidade_Aluno", "Bairro_Aluno", "UF_Aluno",
    "Nacionalidade_Aluno", "Sexo_Aluno", "DT_Nasc_Aluno", "Status_Aluno"
  ],
  turma: [
    "ID_Turma", "DT_Inicio_Turma", "DT_Termino_Turma", "Status_Turma",
    "Nome_Curso", "Area_Curso", "Tipo_Curso", "Grau_Curso",
    "Modalidade_Turma", "Nome_Campus", "Cidade_Turma", "Turno_turma"
  ],
  adesao: [
    "ID_Aluno", "DtNasc_Aluno", "Sexo_Aluno", "EstCivil_Aluno", "Status_Aluno",
    "Mod_Curso", "Cod_Turma", "Dt_Publicacao", "Status_Turma", "Nome_Curso",
    "Area_Curso", "Cidade_Curso", "Cidade_Turma", "Uf_Curso", "Dt_Aceite", "Dt_PreInscricao",
    "Dt_Inscricao", "Dt_Matricula"
  ],
  captacao: [
    "Nome_Instituicao", "DT_Registro", "ID_Turma", "Cod_Turma", "Nome_Campus",
    "DT_Inicio_Turma", "DT_Termino_Turma", "Cidade_Turma", "UF_Turma",
    "Nome_Curso", "Modalidade_Curso", "Area_Curso", "ID_Aluno", "Status_Turma"
  ],
  faturamento: [
    "Cod_Turma", "ID_Aluno", "Nome_Curso", "Nome_CursoModalidade", "Total_De_Parcelas",
    "Num_Da_Parcela", "Valor_Recebido", "Valor_Emitido", "Valor_Juros", "Valor_Descontos",
    "Tipo_De_Boleto", "Tipo_Pagamento",
    "Data_Vencimento", "Data_Recebimento"
  ],
  financeiro: [
    "ID_Financeiro", "ID_Aluno", "Status_Aluno", "ID_Turma", "Cod_Turma",
    "Nome_Curso", "Modalidade_Curso", "Vlr_ContaReceber", "Vlr_Desconto",
    "Vlr_Acrescimo", "Vlr_Pago", "DT_Venc_ContaReceber",
    "DT_Rec_ContaReceber", "Qtd_ParcelasEscolhidas", "Qtd_MensalidadesPagas",
    "Qtd_MensalidadesAtrasadas", "Qtd_MensalidadesCanceladas"
  ],
  docente: [
    "ID_Docente", "DDD_Docente", "UF_Docente", "Cidade_Docente",
    "DT_Nasc_Docente", "DT_Ingresso_Docente", "Sexo_Docente", "EstadoCivil_Docente", "Titulacao_Docente",
    "TempoEnsinoSuperior_Docente", "TempoMercado_Docente", "RegimeTrabalho_Docente",
    "HorasSemanais_Docente", "TempoCoordenador_Docente", "HorasSala_Docente",
    "HorasExtraClasse_Docente", "HorasAtendimento_Docente", "IntegranteNDE_Docente"
  ]
}

export const getExpectedColumns = (fileType) => {
  return columnsByType[fileType] || []
}

export const detectDelimiter = (headerLine) => {
  const semicolonCount = (headerLine.match(/;/g) || []).length
  const commaCount = (headerLine.match(/,/g) || []).length
  const tabCount = (headerLine.match(/\t/g) || []).length

  if (semicolonCount === 0 && commaCount === 0 && tabCount === 0) {
    return { detected: null, expected: ';', isValid: false }
  }

  if (semicolonCount >= commaCount && semicolonCount >= tabCount) {
    return { detected: ';', expected: ';', isValid: true }
  }

  if (commaCount > semicolonCount && commaCount >= tabCount) {
    return { detected: ',', expected: ';', isValid: false }
  }

  if (tabCount > semicolonCount && tabCount > commaCount) {
    return { detected: 'TAB', expected: ';', isValid: false }
  }

  return { detected: ';', expected: ';', isValid: true }
}

const CHUNK_SIZE = 50 * 1024
const PREVIEW_ROWS = 10

const getFileExtension = (file) => {
  const name = (file && file.name) || ''
  const dot = name.lastIndexOf('.')
  return dot >= 0 ? name.slice(dot).toLowerCase() : ''
}

const parseCsvPreview = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    const blob = file.slice(0, Math.min(CHUNK_SIZE, file.size))

    reader.onload = (e) => {
      try {
        const text = e.target.result
        const lines = text.split('\n').filter(line => line.trim() !== '')

        if (lines.length === 0) {
          reject(new Error("Arquivo vazio"))
          return
        }

        const headerLine = lines[0]
        const delimiterInfo = detectDelimiter(headerLine)

        if (!delimiterInfo.isValid) {
          const detectedName = delimiterInfo.detected === ','
            ? 'vírgula (,)'
            : delimiterInfo.detected === 'TAB'
              ? 'tabulação (TAB)'
              : 'desconhecido'
          reject(new Error(
            `Delimitador incorreto detectado: ${detectedName}. ` +
            `O sistema espera ponto e vírgula (;) como delimitador. ` +
            `Por favor, ajuste o arquivo e tente novamente.`
          ))
          return
        }

        const headers = lines[0].split(';').map(h => h.trim())

        if (headers.length < 2) {
          reject(new Error(
            `O arquivo parece não estar usando ponto e vírgula (;) como delimitador. ` +
            `Apenas ${headers.length} coluna(s) detectada(s). ` +
            `Por favor, verifique o formato do arquivo.`
          ))
          return
        }

        const dataLines = lines.slice(1, PREVIEW_ROWS + 1)
        const rows = dataLines.map((line) => {
          const values = line.split(';').map(v => v.trim())
          const row = {}
          headers.forEach((header, index) => {
            row[header] = values[index] || ''
          })
          return row
        })

        // Estima o total de linhas a partir dos bytes efetivamente lidos (não do CHUNK_SIZE):
        // se o arquivo coube inteiro no chunk, o total é exato (linhas - cabeçalho).
        const bytesRead = blob.size
        const isPartial = file.size > bytesRead
        const estimatedTotalLines = isPartial
          ? Math.max(0, Math.round((file.size / bytesRead) * lines.length) - 1)
          : lines.length - 1

        resolve({
          headers,
          rows,
          totalLines: rows.length,
          estimatedTotal: estimatedTotalLines,
          isPartialRead: file.size > CHUNK_SIZE
        })
      } catch (error) {
        reject(new Error(error.message || "Erro ao processar arquivo CSV"))
      }
    }

    reader.onerror = () => {
      reject(new Error("Erro ao ler arquivo"))
    }

    reader.readAsText(blob, 'UTF-8')
  })
}

const parseXlsxPreview = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = async (e) => {
      try {
        const XLSX = await import("xlsx")
        const data = new Uint8Array(e.target.result)
        const workbook = XLSX.read(data, { type: "array" })

        const sheetName = workbook.SheetNames[0]
        if (!sheetName) {
          reject(new Error("O arquivo .xlsx não contém nenhuma aba."))
          return
        }

        const sheet = workbook.Sheets[sheetName]
        const matrix = XLSX.utils.sheet_to_json(sheet, {
          header: 1,
          raw: false,
          defval: "",
          blankrows: false
        })

        if (!matrix.length) {
          reject(new Error(`A primeira aba do arquivo ("${sheetName}") está vazia.`))
          return
        }

        const headers = (matrix[0] || []).map((h) => String(h ?? '').trim())
        if (headers.length < 1 || headers.every((h) => !h)) {
          reject(new Error(`A primeira aba do arquivo ("${sheetName}") não possui cabeçalhos válidos.`))
          return
        }

        const dataRows = matrix.slice(1)
        const rows = dataRows.slice(0, PREVIEW_ROWS).map((rawRow) => {
          const row = {}
          headers.forEach((header, index) => {
            row[header] = String(rawRow?.[index] ?? '').trim()
          })
          return row
        })

        resolve({
          headers,
          rows,
          totalLines: rows.length,
          estimatedTotal: dataRows.length,
          isPartialRead: false
        })
      } catch (error) {
        reject(new Error(error?.message || "Erro ao processar arquivo .xlsx"))
      }
    }

    reader.onerror = () => {
      reject(new Error("Erro ao ler arquivo"))
    }

    reader.readAsArrayBuffer(file)
  })
}

export const parseFilePreview = (file) => {
  const ext = getFileExtension(file)
  if (ext === '.xlsx') {
    return parseXlsxPreview(file)
  }
  return parseCsvPreview(file)
}

// Mantido por compatibilidade com chamadas legadas; redireciona para
// `parseFilePreview`, que aceita CSV e XLSX.
export const parseCSVPreview = parseFilePreview
